import {RouteConfig} from "vue-router";
import AuthLogoutView from "@/modules/security/views/AuthLogoutView.vue";
import AuthAcceptInvitationView from "@/modules/security/views/AuthAcceptInvitationView.vue";

const routes: Array<RouteConfig> = [
    {
        path: '/auth/:person/accept',
        component: AuthAcceptInvitationView
    },
    {
        path: '/auth/logout',
        component: AuthLogoutView
    }
];

export default {
    routes: routes
};
